module.exports = __webpack_public_path__ + "static/media/connected-background.ba59ad6a.png";